"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderProductEdition = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _objectSpread5 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _styles = require("./styles");

var _HeaderTop = require("../../molecules/HeaderTop");

var _ImagePreviewer = require("../../organisms/ImagePreviewer");

var _ImageDataTable = require("../../organisms/ImageDataTable");

var _FullProductNameHeader = require("../../organisms/FullProductNameHeader");

var _FullTabsMenu = require("../../organisms/FullTabsMenu");

var _InputGroup = require("../../organisms/InputGroup");

var _react = require("react");

var _GalleryElement = require("../../molecules/GalleryElement");

var _fileSaver = require("file-saver");

var _data = require("../../../global-files/data");

var _GalleryHeader = require("../../molecules/GalleryHeader");

var _ProductImageModal = require("../../organisms/ProductImageModal");

var _reactDropzone = require("react-dropzone");

var _axios = _interopRequireDefault(require("axios"));

var _uuid = require("uuid");

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

var _index = require("../../molecules/TagAndInput/index");

var _GeneralButton = require("../../atoms/GeneralButton");

var _Commentary = require("../../atoms/Commentary");

var _GenericModal = require("../../atoms/GenericModal");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _Loading = require("../../atoms/Loading");

var _genericModalCheck = _interopRequireDefault(require("../../../assets/images/genericModal/genericModalCheck.svg"));

var _reactRouterDom = require("react-router-dom");

var _defaultProfileImage = _interopRequireDefault(require("../../../assets/images/defaultImages/defaultProfileImage.svg"));

var _errorModal = _interopRequireDefault(require("../../../assets/images/genericModal/errorModal.svg"));

var _index2 = require("../../organisms/GlobalModal/index");

var _SliderToolTip = require("../../atoms/SliderToolTip");

var _infoIcon = _interopRequireDefault(require("../../../assets/images/sliderToolTip/infoIcon.svg"));

var _slide = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide1.svg"));

var _slide2 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide2.svg"));

var _slide3 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide3.svg"));

var _slide4 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide4.svg"));

var _slide5 = _interopRequireDefault(require("../../../assets/images/sliderToolTip/slide5.svg"));

var _VersionSelector = require("../../organisms/VersionSelector");

var _customHooks = require("../../../global-files/customHooks");

var _utils = require("../RetailerProductEdition/utils");

var _Modal = require("../../organisms/Modal");

var _ButtonV = require("../../atoms/ButtonV2");

var _Box = require("../../organisms/Box");

var _jsxRuntime = require("react/jsx-runtime");

var reducerImages = function reducerImages(state, action) {
  var _action$init, _action$init$inputsBy;

  var values = state.values,
      attrForImgs = state.attrForImgs,
      inputsByRetailer = state.inputsByRetailer;

  switch (action.action) {
    case "init":
      var newInputsByRetailer = {};
      action === null || action === void 0 ? void 0 : (_action$init = action.init) === null || _action$init === void 0 ? void 0 : (_action$init$inputsBy = _action$init.inputsByRetailer) === null || _action$init$inputsBy === void 0 ? void 0 : _action$init$inputsBy.forEach(function (inputs) {
        inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function (input) {
          if (!newInputsByRetailer["".concat(input.id_retailer)]) newInputsByRetailer["".concat(input.id_retailer)] = [];
          newInputsByRetailer["".concat(input.id_retailer)].push(input);
        });
      });
      inputsByRetailer = newInputsByRetailer;
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, action.init), {}, {
        inputsByRetailer: inputsByRetailer,
        valuesInitial: action.init.values,
        inputsInitial: action.init.inputs
      });

    case "addImg":
      values = [].concat((0, _toConsumableArray2.default)(values), [action.img]);
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, state), {}, {
        values: values
      });

    case "changeImageInfo":
      values[action.index][action.attribute] = action.value;
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, state), {}, {
        values: values
      });

    case "changeAttrValue":
      var index = attrForImgs.general.findIndex(function (f) {
        return f.id = action.id;
      });

      if (index !== -1) {
        attrForImgs.general[index].value = action.value;
      }

      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, state), {}, {
        attrForImgs: attrForImgs,
        values: values
      });

    case "deleteImage":
      values = values.filter(function (value) {
        return action.selectedImages.indexOf(value) === -1;
      });
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, state), {}, {
        values: values
      });

    case "orderImages":
      {
        var _state$inputsByRetail = state.inputsByRetailer,
            _inputsByRetailer = _state$inputsByRetail === void 0 ? {} : _state$inputsByRetail,
            valuesInitial = state.valuesInitial,
            inputsInitial = state.inputsInitial,
            inputs = state.inputs;

        try {
          var orderedImages = [];
          var imageIdArray = [];

          if (action !== null && action !== void 0 && action.retailerId && !_inputsByRetailer[action.retailerId]) {
            _inputsByRetailer[action.retailerId] = [];
          }

          if (action.retailerId) {
            var _inputsByRetailer$act;

            (_inputsByRetailer$act = _inputsByRetailer[action.retailerId]) === null || _inputsByRetailer$act === void 0 ? void 0 : _inputsByRetailer$act.filter(function (input) {
              imageIdArray.push(input.id_image);
              valuesInitial.forEach(function (value) {
                if (value.image_id === input.id_image) orderedImages.push(value);
              });
            });
          }

          inputs = inputsInitial === null || inputsInitial === void 0 ? void 0 : inputsInitial.filter(function (input) {
            return imageIdArray.includes(input.id);
          });
          values = orderedImages.length > 0 ? orderedImages : [];
        } catch (error) {
          console.log(action.action, error);
        }

        return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, state), {}, {
          values: values,
          inputs: inputs
        });
      }

    default:
      return state;
  }
};

var S3_BUCKET = process.env.REACT_APP_IMAGES_BUCKET;
var REGION = "us-east-1";

_awsSdk.default.config.update({
  accessKeyId: process.env.REACT_APP_KUTS3,
  secretAccessKey: process.env.REACT_APP_AKUTS3
});

var myBucket = new _awsSdk.default.S3({
  params: {
    Bucket: S3_BUCKET
  },
  region: REGION
});

var ProviderProductEdition = function ProviderProductEdition(_ref) {
  var _product$retailers, _product$retailersAva, _location$state4, _location$state5, _location$state6, _datasheets$, _datasheets$$data;

  var tabsSections = _ref.tabsSections,
      _ref$productSelected = _ref.productSelected,
      productSelected = _ref$productSelected === void 0 ? {} : _ref$productSelected,
      productToEdit = _ref.productToEdit,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? {} : _ref$location,
      token = _ref.token,
      _ref$revision = _ref.revision,
      revision = _ref$revision === void 0 ? false : _ref$revision,
      setShowContentohRequestModal = _ref.setShowContentohRequestModal,
      showSurvey = _ref.showSurvey,
      company = _ref.company,
      addToCart = _ref.addToCart;

  var _useState = (0, _react.useState)("Descripción"),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeImage = _useState4[0],
      setActiveImage = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      imageLayout = _useState6[0],
      setImageLayout = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      headerTop = _useState8[0],
      setHeaderTop = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      descriptions = _useState10[0],
      setDescriptions = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      datasheets = _useState12[0],
      setDatasheets = _useState12[1];

  var _useReducer = (0, _react.useReducer)(reducerImages, {}),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      images = _useReducer2[0],
      setImages = _useReducer2[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      showModal = _useState14[0],
      setShowModal = _useState14[1];

  var _useState15 = (0, _react.useState)({}),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      boxData = _useState16[0],
      setBoxData = _useState16[1];

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: "image/*",
    noKeyboard: true,
    multiple: true,
    noClick: true,
    onDrop: function onDrop(acceptedFiles) {
      var newImages = [];
      acceptedFiles.map(function (file) {
        var reader = new FileReader();
        reader.fileName = file.name;

        reader.onload = /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
            var ext, img;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    ext = e.srcElement.fileName.split(".");
                    img = new Image();
                    img.src = e.target.result;
                    setTimeout(function () {
                      var width = img.width;
                      var height = img.height;
                      var newImg = {
                        action: "addImg",
                        img: {
                          src: e.target.result,
                          name: e.target.fileName,
                          ext: ext[ext.length - 1],
                          width: width,
                          height: height,
                          isApproved: true //VALIDAR QUE SOLO SEA PARA RADIOSHACK

                        }
                      };
                      setImages(newImg);
                    }, 500);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();

        reader.onerror = function (error) {
          console.log("dropzoneError: ", error);
        };

        reader.readAsDataURL(file);
        return file;
      });
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  var _useState17 = (0, _react.useState)([]),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      updatedDatasheets = _useState18[0],
      setUpdatedDatasheets = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      updatedDescriptions = _useState20[0],
      setUpdatedDescriptions = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      imagesUploaded = _useState22[0],
      setImagesUploaded = _useState22[1];

  var _useState23 = (0, _react.useState)(),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      dataImages = _useState24[0],
      setDataImages = _useState24[1];

  var _useState25 = (0, _react.useState)(product !== null && product !== void 0 && product.retailers ? new Array(product === null || product === void 0 ? void 0 : (_product$retailers = product.retailers) === null || _product$retailers === void 0 ? void 0 : _product$retailers.length).fill({
    percentage: 0
  }) : new Array(product === null || product === void 0 ? void 0 : (_product$retailersAva = product.retailersAvailable) === null || _product$retailersAva === void 0 ? void 0 : _product$retailersAva.length).fill({
    percentage: 0
  })),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      percentages = _useState26[0],
      setPercentages = _useState26[1];

  var _useState27 = (0, _react.useState)(0),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      activePercentage = _useState28[0],
      setActivePercentage = _useState28[1];

  var _useState29 = (0, _react.useState)({}),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      activeRetailer = _useState30[0],
      setActiveRetailer = _useState30[1];

  var _useState31 = (0, _react.useState)([]),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      services = _useState32[0],
      setServices = _useState32[1];

  var _useState33 = (0, _react.useState)([]),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      servicesData = _useState34[0],
      setServicesData = _useState34[1];

  var _useState35 = (0, _react.useState)(""),
      _useState36 = (0, _slicedToArray2.default)(_useState35, 2),
      message = _useState36[0],
      setMessage = _useState36[1];

  var _useState37 = (0, _react.useState)(JSON.parse(sessionStorage.getItem("productSelected")) ? JSON.parse(sessionStorage.getItem("productSelected")) : productSelected),
      _useState38 = (0, _slicedToArray2.default)(_useState37, 2),
      product = _useState38[0],
      setProduct = _useState38[1];

  var _useState39 = (0, _react.useState)(JSON.parse(sessionStorage.getItem("productEdit")) ? JSON.parse(sessionStorage.getItem("productEdit")) : productToEdit),
      _useState40 = (0, _slicedToArray2.default)(_useState39, 2),
      productEdit = _useState40[0],
      setProductEdit = _useState40[1];

  var _useState41 = (0, _react.useState)(product === null || product === void 0 ? void 0 : product.version),
      _useState42 = (0, _slicedToArray2.default)(_useState41, 2),
      version = _useState42[0],
      setVersion = _useState42[1];

  var _useState43 = (0, _react.useState)({}),
      _useState44 = (0, _slicedToArray2.default)(_useState43, 1),
      comments = _useState44[0];

  var _useState45 = (0, _react.useState)(""),
      _useState46 = (0, _slicedToArray2.default)(_useState45, 2),
      comment = _useState46[0],
      setComment = _useState46[1];

  var _useState47 = (0, _react.useState)(false),
      _useState48 = (0, _slicedToArray2.default)(_useState47, 2),
      crossComment = _useState48[0],
      setCrossComment = _useState48[1];

  var _useState49 = (0, _react.useState)([]),
      _useState50 = (0, _slicedToArray2.default)(_useState49, 2),
      userGroups = _useState50[0],
      setUserGroups = _useState50[1];

  var _useState51 = (0, _react.useState)({}),
      _useState52 = (0, _slicedToArray2.default)(_useState51, 2),
      assig = _useState52[0],
      setAssig = _useState52[1];

  var _useState53 = (0, _react.useState)([]),
      _useState54 = (0, _slicedToArray2.default)(_useState53, 2),
      selectedImages = _useState54[0],
      setSelectedImages = _useState54[1];

  var _useState55 = (0, _react.useState)([]),
      _useState56 = (0, _slicedToArray2.default)(_useState55, 2),
      componentsArray = _useState56[0],
      setComponentsArray = _useState56[1];

  var _useState57 = (0, _react.useState)(false),
      _useState58 = (0, _slicedToArray2.default)(_useState57, 2),
      checkAll = _useState58[0],
      setCheckAll = _useState58[1];

  var isRetailer = user === null || user === void 0 ? void 0 : user.is_retailer;

  var _useState59 = (0, _react.useState)(true),
      _useState60 = (0, _slicedToArray2.default)(_useState59, 2),
      loading = _useState60[0],
      setLoading = _useState60[1];

  var _useState61 = (0, _react.useState)(false),
      _useState62 = (0, _slicedToArray2.default)(_useState61, 2),
      validatedAll = _useState62[0],
      setValidatedAll = _useState62[1];

  var _useState63 = (0, _react.useState)(false),
      _useState64 = (0, _slicedToArray2.default)(_useState63, 2),
      showRejectModal = _useState64[0],
      setShowRejectModal = _useState64[1];

  var _useState65 = (0, _react.useState)({}),
      _useState66 = (0, _slicedToArray2.default)(_useState65, 2),
      approvedInputs = _useState66[0],
      setApprovedInputs = _useState66[1];

  var _useState67 = (0, _react.useState)({}),
      _useState68 = (0, _slicedToArray2.default)(_useState67, 2),
      approvedInputsImages = _useState68[0],
      setApprovedInputsImages = _useState68[1];

  var updateApprovedInputs = function updateApprovedInputs(inputId) {
    setApprovedInputs(function (prevInputs) {
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prevInputs), {}, (0, _defineProperty2.default)({}, inputId, true));
    });
  };

  var updateApprovedInputsImages = function updateApprovedInputsImages(inputId) {
    setApprovedInputsImages(function (prevInputs) {
      return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prevInputs), {}, (0, _defineProperty2.default)({}, inputId, true));
    });
  };

  var _useState69 = (0, _react.useState)({
    "Ficha técnica": null,
    Descripción: null,
    Imágenes: null
  }),
      _useState70 = (0, _slicedToArray2.default)(_useState69, 2),
      origin = _useState70[0],
      setOrigin = _useState70[1];

  var _useState71 = (0, _react.useState)(false),
      _useState72 = (0, _slicedToArray2.default)(_useState71, 2),
      inCart = _useState72[0],
      setInCart = _useState72[1];

  var _useState73 = (0, _react.useState)({
    message: "¿Estás seguro de continuar?",
    detail: " ".concat(user.is_retailer ? "Asegurate de haber revisado las tres secciones" : "Envíar el producto a la cadena"),
    button1: {
      name: "Cerrar",
      action: closeGlobalModal
    },
    button2: {
      name: "Continuar",
      action: function action() {
        return evaluationToRetailer(false);
      }
    },
    img: _defaultProfileImage.default
  }),
      _useState74 = (0, _slicedToArray2.default)(_useState73, 2),
      dataGenericModal = _useState74[0],
      setDataGenericModal = _useState74[1];

  var _useState75 = (0, _react.useState)(null),
      _useState76 = (0, _slicedToArray2.default)(_useState75, 2),
      socketType = _useState76[0],
      setSocketType = _useState76[1];

  var _useState77 = (0, _react.useState)(loading),
      _useState78 = (0, _slicedToArray2.default)(_useState77, 2),
      saving = _useState78[0],
      setSaving = _useState78[1];

  var _useState79 = (0, _react.useState)(product.statusByRetailer),
      _useState80 = (0, _slicedToArray2.default)(_useState79, 2),
      retailerStatus = _useState80[0],
      setRetailerStatus = _useState80[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)("version-selector"),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showVersionSelector = _useCloseModal2[0],
      setShowVersionSelector = _useCloseModal2[1];

  var _useState81 = (0, _react.useState)(),
      _useState82 = (0, _slicedToArray2.default)(_useState81, 2),
      globalModal = _useState82[0],
      setGlobalModal = _useState82[1];

  var updateAuditStatus = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(status) {
      var productTemp, retailerStatusCopy, conceptArray;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              productTemp = product;
              productTemp.article_status = status;
              productTemp.datasheet_status = status;
              productTemp.description_status = status;
              productTemp.images_status = status;
              retailerStatusCopy = (0, _objectSpread5.default)({}, retailerStatus);
              conceptArray = ["description", "datasheet", "images"];
              Object.keys(retailerStatusCopy).forEach(function (key) {
                conceptArray.forEach(function (concept) {
                  if (retailerStatusCopy[key][concept]) {
                    retailerStatusCopy[key][concept] = status;
                  }
                });
              });
              setRetailerStatus(retailerStatusCopy);
              productTemp.statusByRetailer = retailerStatusCopy;
              setProduct(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setProductEdit({
                ArticleId: productTemp.id_article,
                idCategory: productTemp.article.id_category,
                product: productTemp
              });
              sessionStorage.setItem("productEdit", JSON.stringify({
                ArticleId: productTemp.id_article,
                idCategory: productTemp.article.id_category,
                product: productTemp
              }));
              _context2.next = 16;
              return loadData();

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAuditStatus(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var addCart = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(retailers) {
      var article, version, articleToOrder, modatlType, resCart;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              article = product.article, version = product.version;
              articleToOrder = [{
                articleId: article.id_article,
                version: version,
                userId: user.id_user,
                discount: 0,
                subtotal: 0,
                companyId: user.id_company,
                datasheet: retailers,
                description: retailers,
                image: retailers,
                attributeTranslations: false,
                descriptionTranslations: false,
                build: "[]",
                manual: "[]",
                userCreated: user.id_user
              }];
              modatlType = "addedToCartError";

              if (!addToCart) {
                _context3.next = 8;
                break;
              }

              _context3.next = 6;
              return addToCart({
                data: articleToOrder
              });

            case 6:
              resCart = _context3.sent;

              if (resCart.data.statusCode === 200) {
                modatlType = "addedToCart";
              }

            case 8:
              showGlobalModal(modatlType);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function addCart(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var closeGlobalModal = function closeGlobalModal() {
    return setGlobalModal();
  };

  var seenByProvider = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _productTemp$id_order;

      var productTemp, articleId, orderId, promises, conceptArray;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              productTemp = product;
              articleId = productTemp.id_article;
              orderId = (_productTemp$id_order = productTemp.id_order) !== null && _productTemp$id_order !== void 0 ? _productTemp$id_order : productTemp.orderId;
              promises = [];
              conceptArray = ["description", "datasheet", "images"];
              conceptArray.forEach(function (concept) {
                var sectionStatusKey = "".concat(concept, "_status");
                var evalStatus = product[sectionStatusKey] || (product === null || product === void 0 ? void 0 : product.version_status);
                var data = {
                  articleId: articleId,
                  orderId: orderId,
                  concept: concept,
                  evalStatus: evalStatus
                };
                promises.push(_axios.default.put("".concat(process.env.REACT_APP_SEND_EVAL), data, {
                  headers: {
                    Authorization: token
                  }
                }));
              });
              _context4.next = 8;
              return Promise.all(promises);

            case 8:
              closeGlobalModal();
              _context4.next = 11;
              return updateAuditStatus("FAP");

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function seenByProvider() {
      return _ref5.apply(this, arguments);
    };
  }();

  var showGlobalModal = (0, _react.useCallback)(function (type) {
    var formatter = new Intl.ListFormat("es", {
      type: "conjunction"
    });

    switch (type) {
      case "generic":
        setGlobalModal(dataGenericModal);
        break;

      case "commentsSent":
        setGlobalModal({
          message: "Gracias, tus comentarios fueron entregados.",
          detail: "Trabajaremos en conjunto para resolverlo.",
          button1: {
            name: "Cerrar",
            action: closeGlobalModal
          },
          img: _defaultProfileImage.default,
          textArea: false
        });
        break;

      case "RAC":
        var servicesRejected = [];
        var translateServices = {
          datasheet: "ficha técnica",
          description: "descripción",
          images: "imágenes"
        };
        Object.keys(translateServices).forEach(function (service) {
          if (product["".concat(service, "_status")] === "RAC") {
            servicesRejected.push(translateServices[service]);
          }
        });
        var plural = ["Los servicios", "cumplen"];
        var singular = ["El servicio", "cumple"];
        var grammar = servicesRejected.length > 1 ? plural : singular;
        var formatted = formatter.format(servicesRejected);
        var text1 = "".concat(grammar[0], " de ").concat(formatted, " no ").concat(grammar[1], " con lo que la cadena necesita.");
        var text2 = "\xA1Solicita el servicio de Content-oh! para completarlo!";
        var retailers = product.retailersWithService.map(function (retailer) {
          return Number(retailer);
        });
        setGlobalModal({
          message: "Tu producto no cumple con los requerimientos de la cadena",
          customComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
              className: "generic-text",
              children: [text1, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), text2]
            })
          }),
          button1: {
            name: "Continuar",
            action: function () {
              var _action = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
                return _regenerator.default.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return seenByProvider();

                      case 2:
                        return _context5.abrupt("return", _context5.sent);

                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              function action() {
                return _action.apply(this, arguments);
              }

              return action;
            }()
          },
          button2: {
            name: "Solicitar a Content-oh!",
            action: function () {
              var _action2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
                return _regenerator.default.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return addCart(retailers);

                      case 2:
                        _context6.next = 4;
                        return seenByProvider();

                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              function action() {
                return _action2.apply(this, arguments);
              }

              return action;
            }()
          },
          img: _errorModal.default
        });
        break;

      case "AAC":
        setGlobalModal({
          message: "Felicidades",
          detail: "Tu producto cumple con los requerimientos de la cadena.",
          button1: {
            name: "Continuar",
            action: function () {
              var _action3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
                return _regenerator.default.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return seenByProvider();

                      case 2:
                        return _context7.abrupt("return", _context7.sent);

                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              function action() {
                return _action3.apply(this, arguments);
              }

              return action;
            }()
          },
          img: _defaultProfileImage.default
        });
        break;

      case "addedToCartError":
        setGlobalModal({
          detail: "Parece que algo salió mal al intentar añadir tu producto a tu carrito.",
          button1: {
            name: "Continuar",
            action: closeGlobalModal
          }
        });
        break;

      case "addedToCart":
        setGlobalModal({
          message: "Producto añadido",
          detail: "Tu producto se añadió al carrito de compras.",
          button1: {
            name: "Continuar",
            action: closeGlobalModal
          },
          img: _defaultProfileImage.default
        });
        break;

      default:
        closeGlobalModal();
        break;
    }
  }, [activeTab, dataGenericModal, product]);
  (0, _react.useEffect)(function () {
    checkAll && setSelectedImages(images.values);
  }, [checkAll]);
  (0, _react.useEffect)(function () {
    if (showModal) {
      setActiveTab("Imágenes");
    }
  }, [showModal]);
  (0, _react.useEffect)(function () {
    var _location$state, _location$state2, _location$state3;

    setOrigin({
      "Ficha técnica": location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.origin,
      Descripción: location === null || location === void 0 ? void 0 : (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.origin,
      Imágenes: location === null || location === void 0 ? void 0 : (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.origin
    });
  }, [location === null || location === void 0 ? void 0 : (_location$state4 = location.state) === null || _location$state4 === void 0 ? void 0 : _location$state4.origin]);

  var loadData = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      var _product$article, _product$article2, _product$article3, _services$, _services$$values, _product$retailersAva2;

      var services, data, headers;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return (0, _data.getRetailerServices)((product === null || product === void 0 ? void 0 : product.id_article) || (product === null || product === void 0 ? void 0 : (_product$article = product.article) === null || _product$article === void 0 ? void 0 : _product$article.id_article), (product === null || product === void 0 ? void 0 : (_product$article2 = product.article) === null || _product$article2 === void 0 ? void 0 : _product$article2.company_name) || (product === null || product === void 0 ? void 0 : product.categoryName), parseInt((product === null || product === void 0 ? void 0 : (_product$article3 = product.article) === null || _product$article3 === void 0 ? void 0 : _product$article3.id_category) || (product === null || product === void 0 ? void 0 : product.id_category)), version, token);

            case 2:
              services = _context8.sent;
              //Converts the data inside the datasheets object to array
              setServices(services);
              _context8.next = 6;
              return getServices();

            case 6:
              setImages({
                action: "init",
                init: services[2]
              });
              if (((_services$ = services[2]) === null || _services$ === void 0 ? void 0 : (_services$$values = _services$.values) === null || _services$$values === void 0 ? void 0 : _services$$values.length) > 0) setActiveImage(0);
              data = [{
                id_article: product.id_article,
                id_category: product.id_category,
                version: product.version,
                id_retailer_array: ((_product$retailersAva2 = product.retailersAvailable) !== null && _product$retailersAva2 !== void 0 ? _product$retailersAva2 : product.retailers).map(function (_ref7) {
                  var id = _ref7.id;
                  return id;
                })
              }];
              headers = {
                Authorization: token
              };
              (0, _data.getPercentage)({
                data: data,
                headers: headers
              }).then(function (res) {
                setPercentages(res[0]);
              });
              setLoading(false);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function loadData() {
      return _ref6.apply(this, arguments);
    };
  }();

  var getServices = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      var _product$article4;

      var productInOrder, idArticle, retailers, active, _product$id_order, _servicesResponse$dat, servicesResponse, parsedResponse, retailerResponse;

      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              productInOrder = product.id_order || product.orderId;
              idArticle = (product === null || product === void 0 ? void 0 : product.id_article) || (product === null || product === void 0 ? void 0 : (_product$article4 = product.article) === null || _product$article4 === void 0 ? void 0 : _product$article4.id_article);
              retailers = product.retailers || product.retailersAvailable;
              active = null;

              if (!(isRevision() || productInOrder)) {
                _context9.next = 12;
                break;
              }

              _context9.next = 7;
              return _axios.default.get("".concat(process.env.REACT_APP_SERVICES_ENDPOINT, "?articleId=").concat(idArticle, "&orderId=").concat((_product$id_order = product === null || product === void 0 ? void 0 : product.id_order) !== null && _product$id_order !== void 0 ? _product$id_order : product.orderId, "&end=true"));

            case 7:
              servicesResponse = _context9.sent;
              parsedResponse = JSON.parse(servicesResponse === null || servicesResponse === void 0 ? void 0 : (_servicesResponse$dat = servicesResponse.data) === null || _servicesResponse$dat === void 0 ? void 0 : _servicesResponse$dat.body).data;
              retailerResponse = parsedResponse === null || parsedResponse === void 0 ? void 0 : parsedResponse.map(function (srv) {
                return srv.id_retailer;
              });
              active = retailers === null || retailers === void 0 ? void 0 : retailers.find(function (retailer) {
                return retailerResponse.includes(retailer.id);
              });
              setServicesData(parsedResponse);

            case 12:
              retailers && !activeRetailer.id && setActiveRetailer(active ? active : retailers[0]);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function getServices() {
      return _ref8.apply(this, arguments);
    };
  }();

  var isRevision = function isRevision() {
    if (productEdit) {
      var concept = getConcept(activeTab);

      var _isRetailer = user.is_retailer === 1;

      var currentService = productEdit === null || productEdit === void 0 ? void 0 : productEdit.product["".concat(concept, "_status")];
      var orgn = origin[activeTab];

      var _revision = ["RequestWithContentoh", "RequestWithoutContentoh", "Contentoh"].includes(orgn);

      if (_isRetailer) {
        if (_revision && currentService === "AP") return true;
      } else {
        var _product = productEdit.product;
        var isRequestWithoutContentoh = orgn === "RequestWithoutContentoh" && (["R", "CA"].includes(currentService) || currentService === "RCA" && (!_product.id_order || !_product.orderId));
        var isRequestWithContentoh = orgn === "RequestWithContentoh" && currentService === "AA";
        var isContentoh = orgn === "Contentoh" && currentService === "AA";
        if (isContentoh || isRequestWithoutContentoh || isRequestWithContentoh) return true;
      }
    }

    return false;
  };

  var getCart = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      var _Object$values;

      var res, arr;
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _axios.default.get("".concat(process.env.REACT_APP_CART, "/general/"), {
                headers: {
                  Authorization: token
                }
              });

            case 2:
              res = _context10.sent;
              arr = (_Object$values = Object.values(JSON.parse(res.data.body).data)) === null || _Object$values === void 0 ? void 0 : _Object$values.map(function (e) {
                return e.article_id;
              }).filter(Boolean);
              setInCart(arr.some(function (e) {
                return e.articleId === product.id_article;
              }));

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function getCart() {
      return _ref9.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    sessionStorage.setItem("user", JSON.stringify(user));
    loadData();
    getCart();
    (0, _data.fetchUsers)(token).then(function (res) {
      return setUserGroups(res);
    });
    setImages({
      action: "orderImages",
      retailerId: activeRetailer.id
    });
    if (["RAC", "AAC"].includes(product.article_status)) showGlobalModal(product.article_status);
  }, [product, version]);
  (0, _react.useEffect)(function () {
    setImages({
      action: "orderImages",
      retailerId: activeRetailer.id
    });
  }, [activeRetailer]);

  var loadAssignations = function loadAssignations(currentProduct) {
    setAssig(product === null || product === void 0 ? void 0 : product.asignations);
  };

  (0, _react.useEffect)(function () {
    loadAssignations(product);
  }, [userGroups]);
  (0, _react.useEffect)(function () {
    var _Object$keys, _percentages$productT, _retailers$;

    var productTemp = product;
    var retailers = (productTemp === null || productTemp === void 0 ? void 0 : productTemp.retailersAvailable) || (productTemp === null || productTemp === void 0 ? void 0 : productTemp.retailers);

    if (((_Object$keys = Object.keys((_percentages$productT = percentages[productTemp.id_article]) !== null && _percentages$productT !== void 0 ? _percentages$productT : {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
      retailers === null || retailers === void 0 ? void 0 : retailers.forEach(function (retailer, index) {
        var _percentages$productT2;

        retailer["percentage"] = Number((_percentages$productT2 = percentages[productTemp.id_article][retailer.id]) === null || _percentages$productT2 === void 0 ? void 0 : _percentages$productT2.percentageRequired);
      });
    }

    setProduct(productTemp);
    retailers && setActivePercentage((_retailers$ = retailers[0]) === null || _retailers$ === void 0 ? void 0 : _retailers$.percentage);
  }, [percentages]);

  var loadInputs = function loadInputs() {
    if (services.length > 0) {
      var _services$0$activeRet, _services$2, _services$3;

      if ((_services$0$activeRet = services[0][activeRetailer.id]) !== null && _services$0$activeRet !== void 0 && _services$0$activeRet.data) services[0][activeRetailer.id].data = Object.values(services[0][activeRetailer.id].data);
      setActivePercentage(Math.round(activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.percentage, 0));
      var datagroups = services[0][activeRetailer.id];
      var inputs = (_services$2 = services[0]) === null || _services$2 === void 0 ? void 0 : _services$2.inputs;

      var _descriptions = (_services$3 = services[1]) === null || _services$3 === void 0 ? void 0 : _services$3.filter(function (service) {
        return (service === null || service === void 0 ? void 0 : service.id) === (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id);
      });

      setDatasheets([datagroups, inputs]);
      setDescriptions(_descriptions);
    }
  };

  (0, _react.useEffect)(function () {
    loadInputs();
    activeRetailer.id && setImages({
      action: "orderImages",
      retailerId: activeRetailer.id
    });
  }, [servicesData, activeRetailer, services]);

  var thumbs = function thumbs() {
    var _images$imageType, _images$imagePackagin, _images$values;

    var imageInputs = socketType === null || socketType === void 0 ? void 0 : socketType.slice();
    var imageType = images === null || images === void 0 ? void 0 : (_images$imageType = images.imageType) === null || _images$imageType === void 0 ? void 0 : _images$imageType.map(function (e) {
      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name
      };
    });
    var imagePackagingType = images === null || images === void 0 ? void 0 : (_images$imagePackagin = images.imagePackagingType) === null || _images$imagePackagin === void 0 ? void 0 : _images$imagePackagin.map(function (e) {
      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name
      };
    });
    return images === null || images === void 0 ? void 0 : (_images$values = images.values) === null || _images$values === void 0 ? void 0 : _images$values.map(function (image, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GalleryElement.GalleryElement, {
        setCheckAll: setCheckAll,
        image: image,
        gridLayout: imageLayout,
        id: "gallery-element-" + index,
        index: index + "-" + image.name,
        number: index,
        imageType: imageType,
        imagePackagingType: imagePackagingType,
        imageInputs: imageInputs,
        changeImage: setImages,
        selectedImages: selectedImages,
        setSelectedImages: setSelectedImages,
        updateApprovedInputsImages: updateApprovedInputsImages
      }, index);
    });
  };

  (0, _react.useEffect)(function () {
    var _images$inputs;

    var imageInputs = images === null || images === void 0 ? void 0 : (_images$inputs = images.inputs) === null || _images$inputs === void 0 ? void 0 : _images$inputs.map(function (e) {
      var _images$values2;

      return {
        value: e === null || e === void 0 ? void 0 : e.id,
        name: e === null || e === void 0 ? void 0 : e.name,
        required: e === null || e === void 0 ? void 0 : e.required,
        active: images === null || images === void 0 ? void 0 : (_images$values2 = images.values) === null || _images$values2 === void 0 ? void 0 : _images$values2.some(function (value) {
          return (value === null || value === void 0 ? void 0 : value.image_id) === (e === null || e === void 0 ? void 0 : e.id);
        })
      };
    });
    setSocketType(imageInputs);
  }, [images]);

  var saveDescriptions = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
      var dataObject, res;
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              //GUARDAS DESCRIPCIONES
              setLoading(true);
              dataObject = {
                articleId: product === null || product === void 0 ? void 0 : product.id_article,
                articleData: updatedDescriptions
              };
              dataObject.articleData = dataObject.articleData.map(function (item) {
                var attributeId = item.attributeId; //if (approvedInputs.hasOwnProperty(attributeId)) {

                item.isApproved = true; //}

                return item;
              });
              if (product !== null && product !== void 0 && product.orderId) dataObject["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              console.log("dataObject", dataObject);
              _context11.prev = 5;
              _context11.next = 8;
              return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?description=true&version=").concat(version), dataObject, {
                headers: {
                  Authorization: token
                }
              });

            case 8:
              res = _context11.sent;

              if (!(res.data.statusCode === 200)) {
                _context11.next = 14;
                break;
              }

              setUpdatedDescriptions([]);
              setMessage("Descripciones guardadas con éxito");
              _context11.next = 14;
              return loadData();

            case 14:
              _context11.next = 19;
              break;

            case 16:
              _context11.prev = 16;
              _context11.t0 = _context11["catch"](5);
              console.log(_context11.t0);

            case 19:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[5, 16]]);
    }));

    return function saveDescriptions() {
      return _ref10.apply(this, arguments);
    };
  }();

  var saveDatasheets = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      var parseBoxData, dataObject, res;
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              parseBoxData = [];
              Object.entries(boxData).forEach(function (_ref12, index) {
                var _ref13 = (0, _slicedToArray2.default)(_ref12, 2),
                    box = _ref13[1];

                var value = box.value;
                var attributesIds = Object.keys(value);
                attributesIds.forEach(function (attributeId) {
                  var boxId = index + 1;
                  var valueOfAtribute = value[attributeId];
                  parseBoxData.push({
                    attributeId: attributeId,
                    value: valueOfAtribute,
                    boxId: boxId
                  });
                });
              });
              dataObject = (0, _objectSpread5.default)({
                articleId: product === null || product === void 0 ? void 0 : product.id_article,
                articleData: updatedDatasheets
              }, parseBoxData.length > 0 && {
                boxData: parseBoxData
              });
              dataObject.articleData = dataObject.articleData.map(function (item) {
                var attributeId = item.attributeId;

                if (approvedInputs.hasOwnProperty(attributeId)) {
                  item.isApproved = true;
                }

                return item;
              });
              if (product !== null && product !== void 0 && product.orderId) dataObject["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              _context12.prev = 5;
              _context12.next = 8;
              return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?datasheet=true&version=").concat(version), dataObject, {
                headers: {
                  Authorization: token
                }
              });

            case 8:
              res = _context12.sent;

              if (!(res.data.statusCode === 200)) {
                _context12.next = 14;
                break;
              }

              setUpdatedDatasheets([]);
              setMessage("Fichas técnicas guardadas");
              _context12.next = 14;
              return loadData();

            case 14:
              _context12.next = 19;
              break;

            case 16:
              _context12.prev = 16;
              _context12.t0 = _context12["catch"](5);
              console.log(_context12.t0);

            case 19:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[5, 16]]);
    }));

    return function saveDatasheets() {
      return _ref11.apply(this, arguments);
    };
  }();

  var updateImages = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
    var _images$values3, _data$articleData, _data$articleData2, _data$updateImages;

    var imagesList, imagesListTemp, duplicated, attrForImgs, data, valid, _data$updateImages2, _data$articleData3, _data$articleData4, _data$articleData5, promiseArray;

    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            imagesList = images === null || images === void 0 ? void 0 : (_images$values3 = images.values) === null || _images$values3 === void 0 ? void 0 : _images$values3.slice();
            imagesListTemp = imagesList === null || imagesList === void 0 ? void 0 : imagesList.reduce(function (acc, image) {
              acc[image === null || image === void 0 ? void 0 : image.image_id] = ++acc[image === null || image === void 0 ? void 0 : image.image_id] || 0;
              return acc;
            }, {});
            duplicated = imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (image) {
              return imagesListTemp[image === null || image === void 0 ? void 0 : image.image_id];
            });
            attrForImgs = Object.values(images === null || images === void 0 ? void 0 : images.attrForImgs);
            attrForImgs.pop();
            data = {
              articleId: product === null || product === void 0 ? void 0 : product.id_article,
              attrReqImgs: attrForImgs === null || attrForImgs === void 0 ? void 0 : attrForImgs.map(function (e) {
                var _e$, _e$2;

                return {
                  attrId: (_e$ = e[0]) === null || _e$ === void 0 ? void 0 : _e$.id,
                  value: (_e$2 = e[0]) === null || _e$2 === void 0 ? void 0 : _e$2.value
                };
              }),
              articleData: imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (e) {
                return !e.id;
              }),
              updateImages: imagesList === null || imagesList === void 0 ? void 0 : imagesList.filter(function (e) {
                return e.id;
              })
            };
            if (product !== null && product !== void 0 && product.orderId) data["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
            valid = (data === null || data === void 0 ? void 0 : (_data$articleData = data.articleData) === null || _data$articleData === void 0 ? void 0 : _data$articleData.length) === 0 ? true : data === null || data === void 0 ? void 0 : (_data$articleData2 = data.articleData) === null || _data$articleData2 === void 0 ? void 0 : _data$articleData2.every(function (e, i) {
              if (e !== null && e !== void 0 && e.image_id && e !== null && e !== void 0 && e.packing_type && e !== null && e !== void 0 && e.image_type) {
                return true;
              }

              return false;
            });

            if (valid && (data === null || data === void 0 ? void 0 : (_data$updateImages = data.updateImages) === null || _data$updateImages === void 0 ? void 0 : _data$updateImages.length) > 0 && (duplicated === null || duplicated === void 0 ? void 0 : duplicated.length) === 0) {
              valid = data === null || data === void 0 ? void 0 : (_data$updateImages2 = data.updateImages) === null || _data$updateImages2 === void 0 ? void 0 : _data$updateImages2.every(function (e, i) {
                if (e !== null && e !== void 0 && e.image_id && e !== null && e !== void 0 && e.packing_type && e !== null && e !== void 0 && e.image_type) {
                  return true;
                }

                return false;
              });
            }

            console.log("DATA NEW", data);

            if (!(valid && (duplicated === null || duplicated === void 0 ? void 0 : duplicated.length) === 0)) {
              _context13.next = 33;
              break;
            }

            setLoading(true);
            _context13.prev = 12;
            data === null || data === void 0 ? void 0 : (_data$articleData3 = data.articleData) === null || _data$articleData3 === void 0 ? void 0 : _data$articleData3.forEach(function (e) {
              e.uuid = (0, _uuid.v4)();
            });
            data.updateImages = data.updateImages.map(function (image) {
              return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, image), {}, {
                isApproved: true
              });
              /**if (approvedInputsImages[image.image_id] !== undefined) {
                return {
                  ...image,
                  isApproved: approvedInputsImages[image.image_id],
                };
              }**/

              return image;
            });
            setDataImages(data);

            if (!((data === null || data === void 0 ? void 0 : (_data$articleData4 = data.articleData) === null || _data$articleData4 === void 0 ? void 0 : _data$articleData4.length) > 0)) {
              _context13.next = 25;
              break;
            }

            setImagesUploaded(false);
            promiseArray = [];
            data === null || data === void 0 ? void 0 : (_data$articleData5 = data.articleData) === null || _data$articleData5 === void 0 ? void 0 : _data$articleData5.forEach(function (e) {
              var file = Buffer.from(e.src.replace(/^data:image\/\w+;base64,/, ""), "base64");
              var params = {
                ACL: "public-read",
                Body: file,
                Bucket: S3_BUCKET,
                Key: "id-".concat(data.articleId, "/").concat(version, "/").concat(e === null || e === void 0 ? void 0 : e.image_id, "-").concat(e === null || e === void 0 ? void 0 : e.uuid, ".").concat(e === null || e === void 0 ? void 0 : e.ext)
              };
              promiseArray.push(myBucket.putObject(params).promise());
            });
            _context13.next = 22;
            return Promise.all(promiseArray);

          case 22:
            setImagesUploaded(true);
            _context13.next = 26;
            break;

          case 25:
            setImagesUploaded(true);

          case 26:
            _context13.next = 31;
            break;

          case 28:
            _context13.prev = 28;
            _context13.t0 = _context13["catch"](12);
            console.log(_context13.t0); // setMainLoading(false);

          case 31:
            _context13.next = 34;
            break;

          case 33:
            // setMainLoading(false);
            setMessage("Completa los campos que solicita cada una de la imágenes o hay imágenes con el mismo tipo de toma.\nRecuerda hay campos obligatorios y no podras avanzar si no estan completos.");

          case 34:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[12, 28]]);
  })), [approvedInputsImages, images, imagesUploaded]);
  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
    var res;
    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!imagesUploaded) {
              _context14.next = 17;
              break;
            }

            dataImages.articleData = dataImages === null || dataImages === void 0 ? void 0 : dataImages.articleData.map(function (e) {
              delete e.src;
              e.imageID = e.image_id;
              e.packingType = e.packing_type;
              e.imageType = e.image_type;
              if (product !== null && product !== void 0 && product.orderId) e["orderId"] = product === null || product === void 0 ? void 0 : product.orderId;
              return e;
            });
            _context14.prev = 2;
            _context14.next = 5;
            return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?image=true&version=").concat(version), dataImages, {
              headers: {
                Authorization: token
              }
            });

          case 5:
            res = _context14.sent;

            if (!(res.data.statusCode === 200)) {
              _context14.next = 12;
              break;
            }

            setImages({});
            setMessage("Imágenes guardadas con éxito");
            sessionStorage.removeItem("imagesList");
            _context14.next = 12;
            return loadData();

          case 12:
            _context14.next = 17;
            break;

          case 14:
            _context14.prev = 14;
            _context14.t0 = _context14["catch"](2);
            console.log(_context14.t0);

          case 17:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[2, 14]]);
  })), [dataImages, imagesUploaded]);

  var getConcept = function getConcept(tab) {
    switch (tab) {
      case "Descripción":
        return "description";

      case "Ficha técnica":
        return "datasheet";

      case "Imágenes":
        return "images";
    }
  };

  var createComment = /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(body) {
      var concept, data;
      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              concept = "";
              _context15.t0 = activeTab;
              _context15.next = _context15.t0 === "Ficha técnica" ? 4 : _context15.t0 === "Imágenes" ? 6 : 8;
              break;

            case 4:
              concept = "datasheet";
              return _context15.abrupt("break", 10);

            case 6:
              concept = "images";
              return _context15.abrupt("break", 10);

            case 8:
              concept = "description";
              return _context15.abrupt("break", 10);

            case 10:
              data = {
                articleId: product === null || product === void 0 ? void 0 : product.id_article,
                orderId: product === null || product === void 0 ? void 0 : product.orderId,
                message: body,
                concept: concept,
                version: version
              };
              _context15.next = 13;
              return _axios.default.post("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT), data, {
                headers: {
                  Authorization: token
                }
              });

            case 13:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function createComment(_x4) {
      return _ref16.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    setComment(comments[activeTab]);
  }, [activeTab]);

  var commentRevised = /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16() {
      var data;
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              data = {
                commentId: comment.id
              };
              _context16.next = 3;
              return _axios.default.put("".concat(process.env.REACT_APP_COMMENTS_ENDPOINT), data, {
                headers: {
                  Authorization: token
                }
              });

            case 3:
              setCrossComment(false);

            case 4:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function commentRevised() {
      return _ref17.apply(this, arguments);
    };
  }();

  var setAssignation = /*#__PURE__*/function () {
    var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(assignationType, assignationId) {
      var concept, productTemp, data;
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              concept = "";
              _context17.t0 = activeTab;
              _context17.next = _context17.t0 === "Ficha técnica" ? 4 : _context17.t0 === "Imágenes" ? 6 : 8;
              break;

            case 4:
              concept = "datasheet";
              return _context17.abrupt("break", 10);

            case 6:
              concept = "images";
              return _context17.abrupt("break", 10);

            case 8:
              concept = "description";
              return _context17.abrupt("break", 10);

            case 10:
              productTemp = product;
              productTemp.article["id_".concat(concept, "_").concat(assignationType)] = assignationId;
              data = {
                articleList: [{
                  orderId: product.orderId,
                  articleId: product === null || product === void 0 ? void 0 : product.id_article
                }],
                concept: concept,
                userId: assignationId
              };
              _context17.next = 15;
              return (0, _axios.default)({
                method: "post",
                url: process.env.REACT_APP_ASSIGNATIONS_ENDPOINT,
                data: data,
                headers: {
                  Authorization: token
                }
              });

            case 15:
              loadAssignations(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));

            case 17:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function setAssignation(_x5, _x6) {
      return _ref18.apply(this, arguments);
    };
  }();

  var downloadImages = function downloadImages() {
    var _images$values4;

    selectedImages.length > 0 ? selectedImages.forEach(function (e) {
      if (e.id) {
        (0, _fileSaver.saveAs)("https://".concat(process.env.REACT_APP_IMAGES_BUCKET, ".s3.amazonaws.com/").concat(e.srcDB), "".concat(product.upc || product.article.upc, "_").concat(e.name, ".").concat(e.ext));
      }
    }) : images === null || images === void 0 ? void 0 : (_images$values4 = images.values) === null || _images$values4 === void 0 ? void 0 : _images$values4.forEach(function (e) {
      if (e.id) {
        (0, _fileSaver.saveAs)("https://".concat(process.env.REACT_APP_IMAGES_BUCKET, ".s3.amazonaws.com/").concat(e.srcDB), "".concat(product.upc || product.article.upc, "_").concat(e.name, ".").concat(e.ext));
      }
    });
  };

  var deleteImages = function deleteImages() {
    setLoading(true);
    var values = images.values;
    var imgsInBack = [];
    selectedImages.forEach(function (selectedImg) {
      if (selectedImg.id) imgsInBack.push(selectedImg);
    });
    var imgsLeft = values.filter(function (value) {
      return selectedImages.indexOf(value) === -1;
    });

    if (imgsInBack.length > 0) {
      var _product$article5;

      var data = {
        articleId: (product === null || product === void 0 ? void 0 : product.id_article) || (product === null || product === void 0 ? void 0 : (_product$article5 = product.article) === null || _product$article5 === void 0 ? void 0 : _product$article5.id_article),
        deleteImages: imgsInBack
      };

      try {
        _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?image=true&version=").concat(version), data, {
          headers: {
            Authorization: token
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    setImages({
      action: "deleteImage",
      selectedImages: selectedImages
    });
    setTimeout(function () {
      setLoading(false);
    }, 500);
    setMessage("");
    setComponentsArray([]);
  };

  var askToDeleteImages = function askToDeleteImages() {
    if (selectedImages.length > 0) {
      setMessage("¿Está seguro de eliminar las imágenes seleccionadas?");
      setComponentsArray([/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        text: "¿Está seguro de eliminar las imágenes seleccionadas?",
        headerType: "retailer-name-header",
        color: "white"
      }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "general-white-button",
        label: "Cancelar",
        onClick: function onClick() {
          return setMessage("");
        }
      }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "general-button-default",
        label: "Aceptar",
        onClick: function onClick() {
          setMessage("");
          deleteImages();
        }
      }, "3")]);
    }
  };

  var sendEvaluation = /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(result) {
      var _productTemp$id_order2;

      var concept, productTemp, articleId, orderId, sectionStatusKey, evalStatus, data, retailerId, res, newStatuses, orderStatus, serviceStatus, newProductEdit, showSurveyByProvider, showSurveyByRetailer, _JSON$parse, newArticleStatus, newServiceStatus, newStatus, retailerStatusCopy, status;

      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              setLoading(true);
              concept = getConcept(activeTab);
              productTemp = product;
              articleId = productTemp.id_article;
              orderId = (_productTemp$id_order2 = productTemp.id_order) !== null && _productTemp$id_order2 !== void 0 ? _productTemp$id_order2 : productTemp.orderId;
              sectionStatusKey = "".concat(getConcept(activeTab), "_status");
              evalStatus = product[sectionStatusKey] || (product === null || product === void 0 ? void 0 : product.version_status);
              data = {
                articleId: articleId,
                orderId: orderId,
                concept: concept,
                evalStatus: evalStatus
              };
              retailerId = activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id;
              _context18.prev = 9;

              if (!result) {
                _context18.next = 27;
                break;
              }

              data.result = result;
              data.retailerId = retailerId;
              _context18.next = 15;
              return _axios.default.put("".concat(process.env.REACT_APP_EVALUATION_ENDPOINT), data, {
                headers: {
                  Authorization: token
                }
              });

            case 15:
              res = _context18.sent;
              newStatuses = JSON.parse(res.data.body);
              orderStatus = newStatuses.newOrderStatus;
              serviceStatus = newStatuses.newServiceStatus[articleId]["".concat(getConcept(activeTab), "Status")];
              newProductEdit = productEdit;
              newProductEdit.product[sectionStatusKey] = serviceStatus;
              setProductEdit(newProductEdit);
              showSurveyByProvider = !user.is_retailer && orderStatus[orderId] === "AP";
              showSurveyByRetailer = user.is_retailer && orderStatus[orderId] === "ACA";
              showSurvey && showSurvey(showSurveyByProvider || showSurveyByRetailer);
              _context18.next = 30;
              break;

            case 27:
              _context18.next = 29;
              return _axios.default.put("".concat(process.env.REACT_APP_SEND_EVAL), data, {
                headers: {
                  Authorization: token
                }
              });

            case 29:
              res = _context18.sent;

            case 30:
              if (res.data.statusCode === 200) {
                _JSON$parse = JSON.parse(res.data.body), newArticleStatus = _JSON$parse.newArticleStatus, newServiceStatus = _JSON$parse.newServiceStatus, newStatus = _JSON$parse.newStatus;
                if (newArticleStatus) productTemp.status = newArticleStatus[articleId];
                retailerStatusCopy = (0, _objectSpread5.default)({}, retailerStatus);
                retailerStatusCopy[activeRetailer.id][concept] = newStatus;
                setRetailerStatus(retailerStatusCopy);
                productTemp.statusByRetailer = retailerStatusCopy;

                if (newServiceStatus) {
                  status = newServiceStatus[articleId]["".concat(concept, "Status")];
                  productTemp["".concat(concept, "_status")] = status;
                }

                setProduct(productTemp);
                sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
                setOrigin(function (prev) {
                  return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, (0, _defineProperty2.default)({}, concept, status));
                });
              }

              _context18.next = 36;
              break;

            case 33:
              _context18.prev = 33;
              _context18.t0 = _context18["catch"](9);
              console.log(_context18.t0);

            case 36:
              loadData();

            case 37:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[9, 33]]);
    }));

    return function sendEvaluation(_x7) {
      return _ref19.apply(this, arguments);
    };
  }();

  var validateAll = /*#__PURE__*/function () {
    var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(result) {
      var _product$id_order2, evaluationArray, conceptArray, dataGeneral, userType, productTemp, status, retailerStatusCopy;

      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              setLoading(true);
              evaluationArray = [];
              conceptArray = ["description", "datasheet", "images"];
              dataGeneral = {
                articleId: product.id_article,
                orderId: (_product$id_order2 = product.id_order) !== null && _product$id_order2 !== void 0 ? _product$id_order2 : product.orderId,
                result: result,
                isAproved: result === "A"
              };
              servicesData === null || servicesData === void 0 ? void 0 : servicesData.forEach(function (ret) {
                var service = ret.service,
                    id_retailer = ret.id_retailer;
                var data = {};
                data = (0, _objectSpread5.default)((0, _objectSpread5.default)({}, dataGeneral), {}, {
                  concept: service,
                  retailerId: id_retailer,
                  evalStatus: retailerStatus[id_retailer][service]
                });
                evaluationArray.push(_axios.default.put("".concat(process.env.REACT_APP_EVALUATION_ENDPOINT), data, {
                  headers: {
                    Authorization: token
                  }
                }));
              });
              _context19.next = 8;
              return Promise.all(evaluationArray);

            case 8:
              userType = user.is_retailer === 1 ? "CA" : "P";
              productTemp = product;
              status = "".concat(result).concat(userType);
              productTemp.article_status = status;
              productTemp.datasheet_status = productTemp.datasheet_status === "NA" ? "NA" : status;
              productTemp.description_status = productTemp.description_status === "NA" ? "NA" : status;
              productTemp.images_status = productTemp.images_status === "NA" ? "NA" : status;
              retailerStatusCopy = (0, _objectSpread5.default)({}, retailerStatus);
              Object.keys(retailerStatusCopy).forEach(function (key) {
                conceptArray.forEach(function (concept) {
                  if (retailerStatusCopy[key][concept]) {
                    retailerStatusCopy[key][concept] = status;
                  }
                });
              });
              setRetailerStatus(retailerStatusCopy);
              productTemp.statusByRetailer = retailerStatusCopy;
              setProduct(productTemp);
              sessionStorage.setItem("productSelected", JSON.stringify(productTemp));
              setProductEdit({
                ArticleId: productTemp.id_article,
                idCategory: productTemp.article.id_category,
                product: productTemp
              });
              sessionStorage.setItem("productEdit", JSON.stringify({
                ArticleId: productTemp.id_article,
                idCategory: productTemp.article.id_category,
                product: productTemp
              }));
              _context19.next = 25;
              return loadData();

            case 25:
              _context19.next = 30;
              break;

            case 27:
              _context19.prev = 27;
              _context19.t0 = _context19["catch"](0);
              console.log(_context19.t0);

            case 30:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[0, 27]]);
    }));

    return function validateAll(_x8) {
      return _ref20.apply(this, arguments);
    };
  }();

  var evaluationToRetailer = /*#__PURE__*/function () {
    var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(result) {
      var data, prod, statusComplete;
      return _regenerator.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              data = {
                articleId: product.id_article,
                companyId: user.is_retailer ? product.provider_company_id : product.retailer_company_id,
                versionId: product.version,
                status: result
              };
              _context20.next = 3;
              return _axios.default.put("".concat(process.env.REACT_APP_RETAILER_REQUEST), data, {
                headers: {
                  Authorization: token
                }
              });

            case 3:
              prod = productEdit;
              statusComplete = user.is_retailer ? "".concat(result, "CA") : "".concat(result, "P");
              prod.product.datasheet_status = statusComplete;
              prod.product.description_status = statusComplete;
              prod.product.images_status = statusComplete;
              prod.product.article_status = statusComplete;
              prod.product.services_status = "[\"".concat(statusComplete, "\",\"").concat(statusComplete, "\",\"").concat(statusComplete, "\"]");
              sessionStorage.setItem("productEdit", JSON.stringify(prod));
              setProduct(prod);
              showGlobalModal("generic");
              _context20.next = 15;
              return loadData();

            case 15:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function evaluationToRetailer(_x9) {
      return _ref21.apply(this, arguments);
    };
  }();

  var getSectionStatus = function getSectionStatus() {
    var concept = getConcept(activeTab);
    return ["AA", "AP", "R", "CA", "RCA"].includes(productEdit.product["".concat(concept, "_status")]);
  };

  var enableActions = function enableActions(versionStatus) {
    try {
      if (versionStatus) {
        return ["AP", "ACA", "RCA", null].includes(versionStatus);
      }

      return true;
    } catch (err) {
      console.log(err, "Unable de check if user is retailer");
      return false;
    }
  };

  (0, _react.useEffect)(function () {
    setSaving(loading);
  }, [loading]);
  var slidefront = [{
    slide: _slide.default,
    description: "Creamos tu contenido, y todo lo que haga falta para tu producto, cada sección puedes socilitar contenido enriquecido, y nosotros lo haremos por ti."
  }, {
    slide: _slide2.default,
    description: "Puedes agregar solicitudes de contenido enriquecido a tu carrito de compra las veces que sean necesarias. Una vez completada tu lista con los servicios necesitados sigue el proceso de compra en checkout."
  }, {
    slide: _slide3.default,
    description: "Revisa el contenido que deseas solicilitar, valida y tambien puedes agregar contenido extra, traducciones, o simplemente completar el checkout."
  }, {
    slide: _slide4.default,
    description: "Elige el tipo de entrega de tu producto, puedes ser recolección en el lugar o por el contrario puedes dejarlo en nuestras oficinas."
  }, {
    slide: _slide5.default,
    title: "Bienvenido al modo Content-oh!",
    description: "Finalmente elige la forma de pago que más te guste, procede con el pago y listo."
  }];

  var sendToEvaluation = function sendToEvaluation(result) {
    if (result === "A") {
      if (origin[activeTab] === "RequestWithoutContentoh" && !user.is_retailer && (!product.id_order || !product.orderId)) {
        setDataGenericModal(function (prev) {
          return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
            button2: {
              name: "Continuar",
              action: function action() {
                return evaluationToRetailer("A");
              }
            }
          });
        });
        showGlobalModal("generic");
      } else if (user.is_retailer) {
        if (product.id_order || product.orderId) {
          sendEvaluation("A");
        } else {
          setDataGenericModal(function (prev) {
            return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
              button2: {
                name: "Continuar",
                action: function action() {
                  return evaluationToRetailer("A");
                }
              }
            });
          });
          showGlobalModal("generic");
        }
      } else {
        sendEvaluation("A");
      }
    } else {
      if (origin === "RequestWithoutContentoh" && !user.is_retailer && (!product.id_order || !product.orderId)) {
        return;
      } else if (user.is_retailer) {
        if (product.id_order || product.orderId) {
          sendEvaluation("R");
        } else {
          setDataGenericModal(function (prev) {
            return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
              button2: {
                name: "Continuar",
                action: function action() {
                  return evaluationToRetailer("R");
                }
              }
            });
          });
          showGlobalModal("generic");
        }
      } else {
        sendEvaluation("R");
      }
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    headerTop: headerTop,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderTop.HeaderTop, {
      setHeaderTop: setHeaderTop,
      withChat: location === null || location === void 0 ? void 0 : (_location$state5 = location.state) === null || _location$state5 === void 0 ? void 0 : _location$state5.withChat,
      chatType: location === null || location === void 0 ? void 0 : (_location$state6 = location.state) === null || _location$state6 === void 0 ? void 0 : _location$state6.chatType,
      productSelected: productSelected,
      token: token,
      activeRetailer: activeRetailer
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "data-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "image-data-panel",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePreviewer.ImagePreviewer, {
          activeImage: images !== null && images !== void 0 && images.values ? images === null || images === void 0 ? void 0 : images.values[activeImage] : {},
          imagesArray: images,
          setActiveImage: setActiveImage,
          setShowModal: setShowModal
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageDataTable.ImageDataTable, {
          lists: images,
          activeImage: images !== null && images !== void 0 && images.values ? images === null || images === void 0 ? void 0 : images.values[activeImage] : {},
          retailerSelected: activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id,
          setImages: setImages,
          assignationsImages: assig,
          imagesStatus: product === null || product === void 0 ? void 0 : product.images_status,
          setAssignation: setAssignation,
          isRetailer: isRetailer,
          onClickSave: function onClickSave() {
            var _product$services;

            return (product === null || product === void 0 ? void 0 : (_product$services = product.services) === null || _product$services === void 0 ? void 0 : _product$services.images) === 1 && updateImages();
          },
          setShowVersionSelector: setShowVersionSelector,
          version: version
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "product-information",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FullProductNameHeader.FullProductNameHeader, {
          headerData: product,
          percent: activePercentage,
          activeRetailer: activeRetailer,
          setActiveRetailer: setActiveRetailer,
          showValidationButtons: isRevision() && getSectionStatus(),
          servicesData: servicesData ? servicesData : null,
          showApproveRejectAll: isRevision() && getSectionStatus(),
          approveAll: function approveAll() {
            if (origin === "RequestWithoutContentoh" && !user.is_retailer && (!product.id_order || !product.orderId)) {
              setDataGenericModal(function (prev) {
                return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
                  button2: {
                    name: "Continuar",
                    action: function action() {
                      return evaluationToRetailer("A");
                    }
                  }
                });
              });
              showGlobalModal("generic");
            } else if (user.is_retailer) {
              if (product.id_order || product.orderId) {
                validateAll("A");
              } else {
                setDataGenericModal(function (prev) {
                  return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
                    button2: {
                      name: "Continuar",
                      action: function action() {
                        return evaluationToRetailer("A");
                      }
                    }
                  });
                });
                showGlobalModal("generic");
              }
            } else {
              validateAll("A");
            }
          },
          rejectAll: function rejectAll() {
            if (origin === "RequestWithoutContentoh" && !user.is_retailer && (!product.id_order || !product.orderId)) {
              return;
            } else if (user.is_retailer) {
              if (product.id_order || product.orderId) {
                setValidatedAll(true);
                setShowRejectModal(true);
              } else {
                setDataGenericModal(function (prev) {
                  return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, prev), {}, {
                    button2: {
                      name: "Continuar",
                      action: function action() {
                        return evaluationToRetailer("R");
                      }
                    }
                  });
                });
                showGlobalModal("generic");
              }
            } else {
              setShowRejectModal(true);
              setValidatedAll(true);
            }
          },
          approve: function approve() {
            return sendToEvaluation("A");
          },
          reject: function reject() {
            setShowRejectModal(true);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullTabsMenu.FullTabsMenu, {
          tabsSections: tabsSections,
          status: activeRetailer !== null && activeRetailer !== void 0 && activeRetailer.id && retailerStatus && retailerStatus[activeRetailer.id] ? retailerStatus[activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id][getConcept(activeTab)] || "NS" : "-",
          activeTab: activeTab,
          setActiveTab: setActiveTab,
          setImageLayout: setImageLayout,
          downloadImages: downloadImages,
          askToDeleteImages: askToDeleteImages,
          assig: assig,
          setAssignation: setAssignation,
          isRetailer: isRetailer,
          showSaveButton: enableActions(product.version_status),
          version: version,
          updatedDescriptions: updatedDescriptions,
          setUpdatedDescriptions: setUpdatedDescriptions,
          updatedDatasheets: updatedDatasheets,
          setUpdatedDatasheets: setUpdatedDatasheets,
          images: images,
          setImages: setImages,
          selectedImages: selectedImages,
          setSelectedImages: setSelectedImages,
          setShowVersionSelector: setShowVersionSelector,
          user: user,
          onClickSave: function onClickSave() {
            switch (activeTab) {
              case "Descripción":
                !saving && saveDescriptions();
                break;

              case "Ficha técnica":
                !saving && saveDatasheets();
                break;

              case "Imágenes":
                !saving && updateImages();
                break;

              default:
                break;
            }
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "services-information-container " + (imageLayout && activeTab === "Imágenes" ? "image-services" : ""),
          children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [!imageLayout && activeTab === "Imágenes" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GalleryHeader.GalleryHeader, {
              setSelectedImages: setSelectedImages,
              checkAll: checkAll,
              setCheckAll: setCheckAll
            }), activeTab === "Ficha técnica" && ((product === null || product === void 0 ? void 0 : product.datasheet_status) !== "NS" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: (_datasheets$ = datasheets[0]) === null || _datasheets$ === void 0 ? void 0 : (_datasheets$$data = _datasheets$.data) === null || _datasheets$$data === void 0 ? void 0 : _datasheets$$data.map(function (dataGroup, index) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputGroup.InputGroup, {
                  articleId: product.id_article,
                  version: version,
                  activeSection: activeTab,
                  inputGroup: dataGroup,
                  dataInputs: datasheets[1],
                  updatedDatasheets: updatedDatasheets,
                  setUpdatedDatasheets: setUpdatedDatasheets,
                  isShowbox: true,
                  activeRetailer: services[0][activeRetailer.id],
                  groupData: services[0][activeRetailer.id].data,
                  setUpdatedBoxData: function setUpdatedBoxData(e) {
                    setBoxData(e);
                  },
                  index: index //enableActions={enableActions(product.version_status)} ADD THIS VALIDATION
                  ,
                  updateApprovedInputs: updateApprovedInputs
                }, index + "-" + activeRetailer.name);
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            })), activeTab === "Descripción" && ((product === null || product === void 0 ? void 0 : product.description_status) !== "NS" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputGroup.InputGroup, {
              activeSection: activeTab,
              inputGroup: descriptions[0],
              updatedDescriptions: updatedDescriptions,
              setUpdatedDescriptions: setUpdatedDescriptions,
              articleId: product === null || product === void 0 ? void 0 : product.id_article,
              version: version,
              isShowbox: false,
              dinamicHeight: true,
              updateApprovedInputs: updateApprovedInputs
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            })), activeTab === "Imágenes" && ((product === null || product === void 0 ? void 0 : product.images_status) !== "NS" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
              className: "container",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread5.default)((0, _objectSpread5.default)({}, getRootProps({
                className: "dropzone"
              })), {}, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread5.default)({}, getInputProps())), /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
                  children: thumbs()
                })]
              }))
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
              text: "No cuentas con este servicio",
              headerType: "input-name-header"
            }))]
          })
        }), isRevision() && getSectionStatus() ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "commentary-box"
        }) : !revision && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "required-inputs-message",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: "Los atributos son requeridos por las plataformas de las cadenas, es muy importante completar los campos requeridos ya que pueden rechazar el producto por falta de informaci\xF3n."
            })
          }), inCart ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, {
              to: "/checkout",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Articulo en carrito"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Ir a checkout"
              })]
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderToolTip.SliderToolTip, {
              infoIcon: _infoIcon.default,
              slidefront: slidefront,
              iconSize: "big-image",
              slidePosition: "top-slide"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
              onClick: function onClick() {
                setShowContentohRequestModal && setShowContentohRequestModal(true);
              },
              buttonType: "general-default-button",
              label: "Enviar a Content-oh!"
            })]
          })]
        })]
      })]
    }), showModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductImageModal.ProductImageModal, {
      images: images,
      setShowModal: setShowModal,
      approveRejectButtons: isRevision() && getSectionStatus(),
      sendToFacilitator: sendToEvaluation
    }), message.length > 0 && !showSurvey && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GenericModal.GenericModal, {
      buttonType: componentsArray.length > 0 && "delete-product",
      componentsArray: componentsArray.length > 0 ? componentsArray : [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _genericModalCheck.default,
        alt: "success icon"
      }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "retailer-name-header",
        text: message,
        color: "white"
      }, "2")],
      onClick: function onClick() {
        return setMessage("");
      }
    }), globalModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.GlobalModal, (0, _objectSpread5.default)({
      close: closeGlobalModal
    }, globalModal)), showVersionSelector && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VersionSelector.VersionSelector, {
      modalId: "version-selector",
      articleId: product.id_article,
      setVersion: setVersion,
      companyName: company.company_name,
      currentVersion: version,
      setShowVersionSelector: setShowVersionSelector,
      jwt: token
    }), showRejectModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      title: "Agregar mensaje de rechazo",
      show: showRejectModal,
      customComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.TagAndInput, {
        inputType: "textarea",
        inputId: "modal-message-box",
        index: 0,
        color: "white"
      }),
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "white",
        label: "Cancelar",
        size: 12,
        onClick: function onClick() {
          setShowRejectModal(false);
        }
      }, "btn-Cancelar"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Aceptar",
        size: 12,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
          var body, messages;
          return _regenerator.default.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  body = document.querySelector("#modal-message-box .ql-container .ql-editor > p").innerHTML;
                  messages = [{
                    type: "message",
                    value: body === null || body === void 0 ? void 0 : body.replace(/<.*?\/?>/gm, "")
                  }];
                  _context21.next = 4;
                  return createComment(messages[0].value);

                case 4:
                  validatedAll ? validateAll("R") : sendToEvaluation("R");
                  setShowRejectModal(false);

                case 6:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21);
        }))
      }, "btn-Aceptar")]
    })]
  });
};

exports.ProviderProductEdition = ProviderProductEdition;